import { Location } from 'history';
import { Redirect, Route } from 'react-router-dom';

import { RedirectToExternal } from './ExternalRedirect';
import { REDIRECT_PATHS } from './paths';
import { isExternalRedirectPathProps } from './types';

export const getRedirects = (location: Location): Array<React.ReactNode> => {
  const { search } = location;
  return REDIRECT_PATHS.flatMap((redirectPath) => {
    if (isExternalRedirectPathProps(redirectPath)) {
      const { fromPaths, toExternalUrl } = redirectPath;
      return fromPaths.map((from: string) => (
        <Route key={from} path={from} exact>
          <RedirectToExternal externalUrl={toExternalUrl} />
        </Route>
      ));
    }

    const { fromPaths, to, redirectProps } = redirectPath;
    return fromPaths.map((from: string) => (
      <Redirect
        key={from}
        from={from}
        to={{
          pathname: to,
          search,
        }}
        exact
        {...redirectProps}
      />
    ));
  });
};
